export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9983.e92e6ea4.jpg";